import { SchedulerLiSurgeonsSettings } from '@lp/features/Scheduler';
import { SchedulerSettingsPageHeader } from '@lp/features/Scheduler/components';

const SCHEDULE_BACK_LINK_PATH = '/schedule/s-li';

export const SLiSchedulerSettings = () => {
  return (
    <div className="flex flex-col p-6 gap-6 min-h-full">
      <SchedulerSettingsPageHeader backLinkPath={SCHEDULE_BACK_LINK_PATH} />
      <SchedulerLiSurgeonsSettings scheduleBackPath={SCHEDULE_BACK_LINK_PATH} />
    </div>
  );
};
